<app-header [showAvatar]="false" title="Payment Run #{{paymentRunId}}" [useTabs]="false">
</app-header>
<div class="body">
  <div class="body-container">
    <app-grid
      [gridName]="gridName"

      [gridBulkSectionName]="gridBulkSectionName"
      [gridColumnsParam]="gridColumnsSection"
      [gridFiltersParam]="gridFiltersSection"
      [gridFilter]=gridFilter
      [gridImport]=false
      [gridSearch]=false
      [gridPanelPreferences]=false
      [gridSearchNotFoundImage]="gridSearchNotFoundImage"
      [gridSearchNotFoundTitle]="gridSearchNotFoundTitle"
      [gridSearchNotFoundDescription]="gridSearchNotFoundDescription"
      (onGetGridData)="getPaymentRuns()"
      [panelFiltersSectionId]="panelFiltersSectionId"
      [panelFiltersGroupDisplayName]="panelFiltersGroupDisplayName">
      <mat-list class="custom-mat-list list-grid-std list-transactions">
        <!-- header -->
        <mat-list-item *ngIf="_skeleton.skeletonGridDataLoader" class="custom-mat-list-item grid-row grid-row-header">
          <div class="cell-wrapper col-first">
            <div class="cell col-transaction-info flex-order order-0">
              <label matLine class="label-header">Transaction</label>
            </div>
          </div>
          <div class="cell-wrapper col-info">
            <div [@onToggleGridColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.transactionCreatedAt]?.visible" class="cell flex-order order-{{_meta.collectionOfMetaFields[_gridCols.transactionCreatedAt]?.priority}}">
              <label matLine class="label-header">Created At</label>
            </div>
            <div [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.transactionKind]?.visible" class="cell col-kind flex-order order-{{_meta.collectionOfMetaFields[_gridCols.transactionKind]?.priority}}">
              <label matLine class="label-header">Kind</label>
            </div>
            <!-- Type -->
            <div [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.transactionType]?.visible" class="cell col-type flex-order order-{{_meta.collectionOfMetaFields[_gridCols.transactionType]?.priority}}">
              <label matLine class="label-header">Invoice</label>
            </div>
            <!-- Payment -->
            <div [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.transactionPayment]?.visible" class="cell col-payment-method flex-order order-{{_meta.collectionOfMetaFields[_gridCols.transactionPayment]?.priority}}">
              <label matLine class="label-header">Payment Method</label>
            </div>
            <!-- Customer -->
            <div [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.transactionAccount]?.visible" class="cell col-customer flex-order order-{{_meta.collectionOfMetaFields[_gridCols.transactionAccount]?.priority}}">
              <label matLine class="label-header">Account</label>
            </div>
          </div>
          <div class="cell-wrapper col-actions">
            <div class="cell"></div>
          </div>
        </mat-list-item>
        <!-- Skeleton grid header -->
        <skeleton-loader-grid-header></skeleton-loader-grid-header>
        <!-- rows -->
        <div *ngIf="_skeleton.skeletonGridDataLoader">
          <mat-list-item *ngFor="let transaction of _grid.collectionOfGridItems; let i = index;" class="custom-mat-list-item grid-row">
            <div class="cell-wrapper col-first">
              <!-- Transaction Info -->
              <div class="cell col-transaction-info flex-order order-0">
                <label class="status">
                  <div [class]="'status-inner'" [ngClass]="{ 'status-authorized': transaction.status === _transactionStatus.authorized, 'status-error': transaction.status === _transactionStatus.error, 'status-refund': transaction.status === _transactionStatus.refund, 'status-settled': transaction.status === _transactionStatus.settled, 'status-declined': transaction.status === _transactionStatus.declined}">
                    <span *ngIf="transaction.status === _transactionStatus.authorized" class="status-label">Authorized</span>
                    <span *ngIf="transaction.status === _transactionStatus.error" class="status-label">Error</span>
                    <span *ngIf="transaction.status === _transactionStatus.refund" class="status-label">Refund</span>
                    <span *ngIf="transaction.status === _transactionStatus.settled" class="status-label">Settled</span>
                    <span *ngIf="transaction.status === _transactionStatus.void" class="status-label">Void</span>
                    <span *ngIf="transaction.status === _transactionStatus.declined" class="status-label">Declined</span>

                  </div>
                </label>
                <div class="cell-inner cell-inner-with-status">
                  <label matLine class="label-primary">{{transaction.currency.symbol}}{{transaction.amount}} <span class="typo caption fw300 semi-condensed">{{transaction.currency.iso3}}</span></label>
                  <label matLine *ngIf="transaction.transactionId" class="label-secondary">Id. {{ transaction.transactionId }}</label>
                  <label matLine *ngIf="!transaction.transactionId" class="label-secondary">Id. {{ transaction.id }}</label>
                </div>
              </div>
            </div>
            <div class="cell-wrapper col-info">
              <!-- Created At -->
              <div [@onToggleGridColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.transactionCreatedAt]?.visible" class="cell flex-order order-{{_meta.collectionOfMetaFields[_gridCols.transactionCreatedAt]?.priority}}">
                <div class="cell-inner">
                  <label matLine class="label-primary">{{transaction.createdAt | dateTz : _dateFormatValues.MMM_DD_YYYY }}</label>
                  <label matLine class="label-secondary">{{ transaction.createdAt | formatFullTime }}</label>
                </div>
              </div>
              <!-- Kind -->
              <div [@onToggleGridColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.transactionKind]?.visible" class="cell col-kind flex-order order-{{_meta.collectionOfMetaFields[_gridCols.transactionKind]?.priority}}">
                <mat-icon *ngIf="transaction.kind === _transactionKind.checkout" svgIcon="ico-kind-checkout" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
                <mat-icon *ngIf="transaction.kind === _transactionKind.cron" svgIcon="ico-kind-cron" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
                <mat-icon *ngIf="transaction.kind === _transactionKind.desktop" svgIcon="ico-kind-desktop" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
                <mat-icon *ngIf="transaction.kind === _transactionKind.retry" svgIcon="ico-kind-retry" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
              </div>
              <!-- Invoice -->
              <div [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.transactionType]?.visible" class="cell col-type flex-order order-{{_meta.collectionOfMetaFields[_gridCols.transactionType]?.priority}}">
                <div class="cell-inner">
                  <a matLine [routerLink]="['/main/invoices/', transaction.invoiceId, 'list']" class="custom-mat-link active">#{{transaction.invoiceId}}</a>
                  <label matLine class="label-secondary">{{transaction.type | titlecase}}</label>
                </div>
              </div>
              <!-- Payment -->
              <div [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.transactionPayment]?.visible" class="cell col-payment-method flex-order order-{{_meta.collectionOfMetaFields[_gridCols.transactionPayment]?.priority}}">
                <label *ngIf="transaction.paymentMethod && transaction.paymentType === _paymentSource.creditCard" class="label-card card-badge">
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'alipay'" svgIcon="card-alipay"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'american_express'" svgIcon="card-amex"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'american express'" svgIcon="card-amex"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'amex'" svgIcon="card-amex"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'americanexpress'" svgIcon="card-amex"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'diners'" svgIcon="card-diners"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'discover'" svgIcon="card-discover"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'elo'" svgIcon="card-elo"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'hypercard'" svgIcon="card-hypercard"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'jcb'" svgIcon="card-jcb"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'maestro'" svgIcon="card-maestro"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'master'" svgIcon="card-master"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'mastercard'" svgIcon="card-master"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'paypal'" svgIcon="card-paypal"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'unionpay'" svgIcon="card-unionpay"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'verve'" svgIcon="card-verve"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod.toLowerCase() === 'visa'" svgIcon="card-visa"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <mat-icon *ngIf="transaction.paymentMethod === _paymentSource.other" svgIcon="ico-card"
                    class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
                  <span class="label-card-number">{{ transaction.paymentAccountNumber }}</span>
                </label>
                <label *ngIf="transaction.paymentMethod && transaction.paymentType === _paymentSource.offline"
                  class="label-card card-badge">
                  <span *ngIf="transaction.paymentMethod === _paymentSource.applePay">Apple Pay</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.amazon">Amazon Pay</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.bacs">Bacs</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.check">Check</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.creditCard">Credit Card</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.directEBanking">SEPA Direct Debit</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.eft">EFT</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.ideal">iDEAL</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.moneyOrder">Money Order</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.other">Other</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.paypal">PayPal</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.qiwiWallet">Qiwi Wallet</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.roku">Roku</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.sepa">SEPA</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.token">Token</span>
                  <span *ngIf="transaction.paymentMethod === _paymentSource.wire_transfer">Wire Transfer</span>
                </label>
              </div>
              <!-- Account -->
              <div [@onColumnStatusChange]="_meta.collectionOfMetaFields[_gridCols.transactionAccount]?.visible" class="cell col-customer flex-order order-{{_meta.collectionOfMetaFields[_gridCols.transactionAccount]?.priority}}">
                <div class="cell-inner">
                  <label matLine *ngIf="transaction.customer" class="label-primary">{{transaction.customer.firstName}} {{transaction.customer.lastName}}</label>
                  <label matLine *ngIf="transaction.customer" class="label-secondary">{{transaction.customer.email}}</label>
                </div>
              </div>
            </div>
            <div class="cell-wrapper col-actions">
              <button mat-icon-button [matMenuTriggerFor]="gridActions" class="custom-mat-icon-button button-actions">
                <mat-icon svgIcon="ico-actions" class="custom-mat-icon ico-size ico-xs"></mat-icon>
              </button>
              <mat-menu #gridActions="matMenu" [overlapTrigger]="false" class="custom-mat-menu-panel">
                <a mat-menu-item [routerLink]="['/main/transactions/transactions-details/', transaction.id]" class="custom-mat-menu-item has--no--icon">View Details</a>
              </mat-menu>
            </div>
          </mat-list-item>
        </div>
        <!-- Skeleton grid body -->
        <skeleton-loader-grid-body></skeleton-loader-grid-body>
      </mat-list>
    </app-grid>
  </div>
</div>
